import { NextPageContext } from 'next';
import redirectToNewsDomain from './redirectToNewsDomain';
import correctLocalizedRoute from './correctLocalizedRoute';

const redirectToNewsAndLocalize = (routePrefix: string) => async (context: {
  req: NextPageContext['req'] & { locale?: string };
  res: NextPageContext['res'];
  asPath: string;
}) => {
  const { req, res, asPath } = context;
  redirectToNewsDomain(asPath)({ req, res });
  correctLocalizedRoute(
    { req, res, asPath },
    routePrefix,
  );
  return {};
};

export default redirectToNewsAndLocalize;
